<script>
import {
    mapGetters
} from 'vuex';
export default {
    name: 'CompetenceCardCourseDataProvider',
    computed: mapGetters('competences', {
		course: 'course',
		courseOptions: 'courseOptions'
    }),
	props: {
		competenceCardId: {
			type: String,
			default: '0'
		},
		courseId: {
			type: String,
			default: '0'
		}
	},
	methods: {
		addCourse({competenceCardId, name, category, courseType, issuer, issued, expires, printOption,  certificationLink}) {
			this.$store.dispatch('competences/addCourse', {
					competenceCardId: competenceCardId,
					categoryGroup: category.group,
					category: category.name,
					courseType: courseType,
					name: name,
					issuer: issuer,
					issued: issued,
					expires: expires,
					printOption: printOption,
					certificationLink: certificationLink
				}); 
		},
		editCourse({competenceCardId, courseId, name, category, courseType, issuer, issued, expires, expirationHandleMode, printOption, certificationLink}) {
			this.$store.dispatch('competences/editCourse', {
				competenceCardId: competenceCardId, 
				courseId: courseId, 
				categoryGroup: category.group,
				category: category.name,
				courseType: courseType,
				name: name,
				issuer: issuer,
				issued: issued,
				expires: expires,
				expirationHandleMode: expirationHandleMode,
				printOption: printOption,
				certificationLink: certificationLink
			});
		},
		deleteCourse({competenceCardId, courseId}) {
			this.$store.dispatch('competences/deleteCourse', {
                competenceCardId: competenceCardId,
				courseId: courseId
            });
		}
	},
    render() {
        if (!this.$scopedSlots.default) {
            return;
        }

        const slotScope = {
			course: this.course(this.competenceCardId, this.courseId),
			courseOptions: this.courseOptions,
			addCourse: this.addCourse,
			editCourse: this.editCourse,
			deleteCourse: this.deleteCourse,
		};

        return this.$scopedSlots.default(slotScope);
    }
}
</script>
